const AboutActions = {
    START_LOAD_VERSION_INFO: "about/start-load-version-info",
    LOADED_VERSION_INFO: "about/loaded-version-info",
    LOAD_VERSION_INFO_ERROR: "about/load-version-info-error",
};

export default AboutActions;



// WEBPACK FOOTER //
// ./app/data/meta/AboutActions.js